import { useRef, useState } from 'react';
import { Vector3, CatmullRomCurve3 } from 'three';
import { useFrame } from '@react-three/fiber';
import CarBody from '../assets/car/CarBody.jsx';
import FlockCar from '../assets/car/FlockCar.jsx';
import CarWheels from '../assets/car/CarWheels.jsx';
import * as roadsPath from '../assets/coordinates/roadsPath.json';



const adjustedPoints = roadsPath.car.map((pos) => {
    return new Vector3(
        parseFloat(pos.x) - 4.4, 
        parseFloat(pos.y), 
        parseFloat(pos.z) - 59.1
    );
});

const spline = new CatmullRomCurve3(adjustedPoints);

function Car({ position = [0, 0, 0], rotation = [0, 0 , 0], scale = [1, 1, 1], startOffset = 0}) {
    const groupRef = useRef();
    const [carPositionOnSpline, setCarPositionOnSpline] = useState(startOffset);

    useFrame((state, delta) => {
        setCarPositionOnSpline((prev) => (prev + 0.008 * delta) % 1);

        const newPosition = spline.getPoint(carPositionOnSpline);
        groupRef.current.position.copy(newPosition);

        const targetPositionOnSpline = (carPositionOnSpline + 0.001) % 1;
        const target = spline.getPoint(targetPositionOnSpline);
        groupRef.current.lookAt(target)
    });


    return (
        <>
            <group ref={groupRef} position={position} rotation={[0, Math.PI , 0]} scale={scale}>
                <CarBody position={[0, 0, 0]} />
                <FlockCar/>
                <CarWheels position={[0, 0.04, 1.72 ]} isRotate={true} />
                <CarWheels position={[0, 0.04, -1.72 ]} isRotate={true} />
            </group>
        </>
    );
}


export default function Cars({ numCars = 4 }) {
    const carOffsets = Array.from({ length: numCars }, (_, index) => index / numCars);
    return (
        <>
            {carOffsets.map((offset, index) => (
                <Car key={index} startOffset={offset} />
            ))}
        </>
    );
}
